module.exports = __webpack_public_path__ + "static/media/card-blog18.ab04bb89.jpg";